var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #2b2b2b;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 75,
    cy: 75.1,
    rx: 75,
    ry: 75
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.3,93.4c-28.3,8.5-51.8,20.9-66.4,35.5l-.6.6c3.9,3.7,8.2,7,12.8,9.8l1-1.2c4-4.9,8.3-9.6,12.8-14.1,12-12,25.7-22.3,40.5-30.6h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,80.8c1.1,15.2,6.8,29.1,15.6,40.4l.4-.4c9.1-9,20.9-17.1,35.2-24.2,12.5-6.2,26.9-11.6,42.3-15.8H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.7,18.4c25.4,25.3,57.3,42,92.3,48.3C145.8,29.3,113.9.2,75.2.2s-20,2-28.9,5.7c3.6,4.4,7.5,8.6,11.4,12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.9,21.5c14.7,14.6,38.1,27,66.4,35.5-14.8-8.3-28.5-18.7-40.5-30.6-4.5-4.4-8.8-9.2-12.8-14.1l-1-1.2c-4.6,2.8-8.9,6.1-12.8,9.8l.6.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.7,132c-4,4-7.8,8.2-11.4,12.6,8.9,3.7,18.7,5.7,28.9,5.7,38.7,0,70.6-29.1,74.8-66.6-35,6.3-66.9,23-92.3,48.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.3,53.8c-14.3-7.1-26.1-15.3-35.2-24.2l-.4-.4C6.8,40.5,1.2,54.4,0,69.6h93.5c-15.5-4.2-29.8-9.6-42.3-15.8h0s0,0,0,0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS);
export default __webpack_public_path__ + "static/media/s.30bb58577f8f3a63177fc452fac72f07.svg";
export { ForwardRef as ReactComponent };